export default __webpack_public_path__ + "82e766546ef049f76b016778dbeedc88.svg";